<form>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field class="w-72">
                <mat-label>pf</mat-label>
                <input matInput type="number" placeholder="pf" 
                       [formField]="form().pf" />
                <span matSuffix>
                    <mat-button-toggle-group [formField]="form().lagging" [hideSingleSelectionIndicator]="true">
                        <mat-button-toggle [value]="true">Lagging</mat-button-toggle>
                        <mat-button-toggle [value]="false">Leading</mat-button-toggle>
                    </mat-button-toggle-group>
                </span>
                @for (error of form().pf().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

    </div>


</form>




